(function () {
  var JQUERY_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.7.1/jquery.min.js';
  var SLICK_JS_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.js';
  var SLICK_CSS_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.css';

  function loadScript(src, id) {
    return new Promise(function (resolve, reject) {
      var existing = document.getElementById(id);
      if (existing) {
        if (existing.dataset.loaded === 'true') {
          resolve();
        } else {
          existing.addEventListener('load', resolve, { once: true });
          existing.addEventListener('error', reject, { once: true });
        }
        return;
      }

      var script = document.createElement('script');
      script.id = id;
      script.src = src;
      script.onload = function () {
        script.dataset.loaded = 'true';
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function loadStylesheet(href, id) {
    return new Promise(function (resolve, reject) {
      var existing = document.getElementById(id);
      if (existing) {
        if (existing.dataset.loaded === 'true') {
          resolve();
        } else {
          existing.addEventListener('load', resolve, { once: true });
          existing.addEventListener('error', reject, { once: true });
        }
        return;
      }

      var link = document.createElement('link');
      link.id = id;
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = function () {
        link.dataset.loaded = 'true';
        resolve();
      };
      link.onerror = reject;
      document.head.appendChild(link);
    });
  }

  function waitForWindowLoad() {
    if (document.readyState === 'complete') {
      return Promise.resolve();
    }
    return new Promise(function (resolve) {
      window.addEventListener('load', resolve, { once: true });
    });
  }

  function ensureSlickLoaded() {
    var cssReady =
      window.jQuery && window.jQuery.fn && window.jQuery.fn.slick
        ? Promise.resolve()
        : loadStylesheet(SLICK_CSS_SRC, 'banner-subscription-slick-css');

    var scriptsReady =
      window.jQuery && window.jQuery.fn && window.jQuery.fn.slick
        ? Promise.resolve()
        : loadScript(JQUERY_SRC, 'banner-subscription-jquery').then(function () {
            return loadScript(SLICK_JS_SRC, 'banner-subscription-slick-js');
          });

    // Wait for the CSS, the scripts, AND full page load (fonts/images/stylesheets)
    // so Slick measures the final, correctly laid-out width instead of a stale one.
    return Promise.all([cssReady, scriptsReady, waitForWindowLoad()]);
  }

  function refreshSlider($track) {
    // Force Slick to re-measure and re-position after layout has settled.
    requestAnimationFrame(function () {
      setTimeout(function () {
        if ($track.hasClass('slick-initialized')) {
          $track.slick('setPosition');
        }
      }, 50);
    });
  }

  function initSliders(root) {
    var scope = root || document;
    var tracks = scope.querySelectorAll('.banner-subscription__slider-track:not(.slick-initialized)');
    if (!tracks.length) return;

    ensureSlickLoaded()
      .then(function () {
        var $ = window.jQuery;

        tracks.forEach(function (track) {
          var $track = $(track);
          if ($track.hasClass('slick-initialized')) return;

          $track.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            adaptiveHeight: true,
            infinite: true,
            autoplay: false,
            prevArrow:
              '<button type="button" class="banner-subscription__slider-arrow banner-subscription__slider-arrow--prev" aria-label="Previous slide"></button>',
            nextArrow:
              '<button type="button" class="banner-subscription__slider-arrow banner-subscription__slider-arrow--next" aria-label="Next slide"></button>',
          });

          refreshSlider($track);
        });
      })
      .catch(function (error) {
        console.error('Banner subscription slider failed to load', error);
      });
  }

  function destroySliders(root) {
    if (!window.jQuery) return;
    var scope = root || document;
    var tracks = scope.querySelectorAll('.banner-subscription__slider-track.slick-initialized');
    tracks.forEach(function (track) {
      window.jQuery(track).slick('unslick');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSliders();
    });
  } else {
    initSliders();
  }

  // Fonts/late-loading assets can still shift layout after 'load' fires in some
  // browsers, so re-sync one more time as a final safety net.
  window.addEventListener(
    'load',
    function () {
      if (!window.jQuery) return;
      document.querySelectorAll('.banner-subscription__slider-track.slick-initialized').forEach(function (track) {
        refreshSlider(window.jQuery(track));
      });
    },
    { once: true }
  );

  document.addEventListener('shopify:section:load', function (event) {
    initSliders(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroySliders(event.target);
  });
})();
